import React from 'react';
import { Input } from '@8powers/ams/components/UI/Form';

const CustomInput = props => {
  const { sameAddress } = props.relatedValues;
  return <Input {...props} disabled={sameAddress} />;
};

export default CustomInput;
